import nextSvg from '../../../assets/svg/arrow-right.svg';
import prevSvg from '../../../assets/svg/arrow-left.svg';

export default Array.from( document.querySelectorAll( '.testimonials' ) ).map( ( testimonials ) => {
	const wrap   = testimonials.querySelector('.testimonials__wrap');
	const items  = testimonials.querySelector('.testimonials__items');
	const slides = Array.from( testimonials.querySelectorAll('.testimonial') );

	wrap.classList.add('swiper-container');
	items.classList.add('swiper-wrapper');
	slides.forEach(testimonial => testimonial.classList.add('swiper-slide'));

	testimonials.insertAdjacentHTML(
		'beforeend',
		`<nav class="testimonials__pagination">
			<div class="swiper-button-prev">${prevSvg}</div>
			<div class="swiper-pagination"></div>
			<div class="swiper-button-next">${nextSvg}</div>
		</nav>`
	);

	testimonials.insertAdjacentHTML(
		'beforeend',
		`<nav class="testimonials__nav">
			<div class="swiper-button-prev">${prevSvg}</div>
			<div class="swiper-button-next">${nextSvg}</div>
		</nav>`
	);

	return new window.Swiper( wrap, {
		direction: 'horizontal',
		// effect: 'fade',
		autoHeight: false,
		speed: 600,
		spaceBetween: 0,
		navigation: {
			prevEl: '.swiper-button-prev',
			nextEl: '.swiper-button-next',
		},
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
			renderBullet: function (index, className) {
				if ( slides[ index ].dataset.thumbnail ) {
					return `<span class="${className}"><img src="${ slides[ index ].dataset.thumbnail }" alt="Go to slide ${index + 1}" /></span>`;
				}

				return `<span class="${className}"></span>`;
			},
		},
	} );
} );
